import axios from 'axios';

const cancelTokenFromSignal = (signal) => {
  const source = axios.CancelToken.source();
  if (!signal) return source.token;
  if (signal.aborted) {
    source.cancel();
    return source.token;
  }

  signal.addEventListener('abort', () => {
    source.cancel();
  }, { once: true });

  return source.token;
};

export default cancelTokenFromSignal;
